import { writeWorkspace } from './workspace-write'
import type { FlashcardsFeRouterCtx } from '../router/flashcards-fe.router-ctx'
import type { WorkspaceDb } from './workspace-tables'

type PermissionContext = Pick<FlashcardsFeRouterCtx, 'writes' | 'afterCommit'> & {
  db(workspaceId: string): WorkspaceDb
  auth: { getUser(): { id: string } }
  afterLocalCommit?(workspaceId: string): void | Promise<void>
}
export type PagePermissionChange = { workspaceId: string; pageId: string } & (
  | { type: 'grant'; principalId: string; level: 1 | 2 | 3 }
  | { type: 'revoke'; principalId: string }
  | { type: 'inheritance'; inheritance: 'inherit' | 'restricted' }
)

/** Sharing edits use the same local replication path as page content edits. */
export async function changePagePermission(ctx: PermissionContext, input: PagePermissionChange): Promise<void> {
  await writeWorkspace(ctx, input.workspaceId, () => ctx.db(input.workspaceId).transaction(async tx => {
    if (input.type === 'inheritance') {
      await tx.query`${tx.pages.update({ inheritance: input.inheritance, editedBy: ctx.auth.getUser().id, updatedAt: new Date() })}
        WHERE ${tx.pages.id.eq(input.pageId)}`.run()
    } else if (input.type === 'revoke') {
      await tx.query`DELETE FROM ${tx.pagePermissions} WHERE ${tx.pagePermissions.pageId.eq(input.pageId)}
        AND ${tx.pagePermissions.principalKind.eq('user')} AND ${tx.pagePermissions.principalId.eq(input.principalId)}`.run()
    } else {
      await tx.query`INSERT INTO ${tx.pagePermissions}(pageId,principalKind,principalId,level)
        VALUES (${input.pageId},'user',${input.principalId},${input.level})
        ON CONFLICT(pageId,principalKind,principalId) DO UPDATE SET level=excluded.level`.run()
    }
  }))
}
